import React from "react";
import EyupSultanSidebar from "../Sidebar/EyupsultanSidebar";
import EyupSultanOtherServices from "../ServiceAreas/EyupsultanServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const EyupSultanIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        FATİH HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Tarihi dokusuyla İstanbul’un kalbinde yer alanEyupSultan ilçesinde, halı ve koltuk
            temizliği hizmetlerimizi en üst hijyen standartlarında sunuyoruz. Modern
            yıkama teknikleriyle donatılmış tesisimizde, halılarınız detaylı temizlik
            süreçlerinden geçerek ilk günkü parlaklığına kavuşur.
          </p>

          <p>
            Koltuk yıkama işlemlerimiz, yerinde ya da fabrikada buharlı sistemlerle
            gerçekleştirilir. Kumaş yapısına uygun deterjanlar ve antibakteriyel çözümler
            ile koltuklarınızdaki kir, toz ve kötü kokular etkili şekilde giderilir.
          </p>

          <p>
            <strong>Fatih’te sunduğumuz başlıca hizmet avantajları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Tarihi yarımadanın her mahallesine ücretsiz servis</li>
            <li>Antibakteriyel ve organik ürünlerle güvenli temizlik</li>
            <li>Yıkama sonrası hızlı kurutma ve özel ambalajlama</li>
            <li>Yorgan, battaniye, perde gibi ev tekstili ürünleri için profesyonel yıkama</li>
            <li>Kısa sürede teslimat garantisi</li>
            <li>Yerinde koltuk yıkama seçeneği</li>
          </ul>

          <p>
            Çapa, Fındıkzade, Aksaray, Cerrahpaşa, Kocamustafapaşa gibi tüm mahallelerde aktif olarak
            hizmet veriyoruz. Mobil ekiplerimiz ile adresinizden ürünlerinizi teslim alıyor,
            işlemler sonrası hijyenik şekilde size geri ulaştırıyoruz.
          </p>

          <p>
            Halı ve koltuklarınızda derinlemesine temizlik, hijyen ve müşteri memnuniyeti için
            bizi tercih edin. Web sitemizden iletişime geçebilir veya hızlı sipariş
            oluşturabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <EyupSultanSidebar />
          <EyupSultanOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default EyupSultanIntro;
